import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';

import { CssBaseline } from '@mui/material';

import { AuthContextProvider, ChangeSetProvider, ConfigContextProvider, ContextMenuProvider, NotificationProvider } from '@@components';

import { PortalThemeProvider } from '../themes/PortalThemeProvider';

const queryClient = new QueryClient();

const AppContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<ConfigContextProvider>
			<SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
				<AuthContextProvider>
					<NotificationProvider>
						<ContextMenuProvider>
							<QueryClientProvider client={queryClient}>
								<ChangeSetProvider>
									<PortalThemeProvider>
										<CssBaseline />
										{children}
									</PortalThemeProvider>
								</ChangeSetProvider>
							</QueryClientProvider>
						</ContextMenuProvider>
					</NotificationProvider>
				</AuthContextProvider>
			</SnackbarProvider>
		</ConfigContextProvider>
	);
};

export default AppContainer;
